/* eslint-disable no-console */
import { useCallback, useMemo, useState } from 'react'

import { ItemType } from '../FilterableListTypes'
import { usePowerPortalWebinar } from '../ListType/PowerPortalWebinar'
import { Teaser } from './Teaser'

type TeaserListPropsType = {
  buttonLabel?: string
  items: ItemType[]
  showButton?: boolean
}

export const TeaserList = ({ items, buttonLabel = '', showButton = true }: TeaserListPropsType) => {
  const [processedData, setProcessedData] = useState<{ items?: ItemType[] } | null>(null)

  // Memoize the responseData object to prevent infinite loops
  const responseData = useMemo(() => ({ items }), [items])

  // Memoize callback to prevent infinite loops
  const handleDataProcessed = useCallback((data: { items?: ItemType[] } | null) => {
    setProcessedData(data)
  }, [])

  usePowerPortalWebinar({
    responseData,
    onDataProcessed: handleDataProcessed,
  })

  // Use processed data if available, otherwise use original items
  const displayItems = processedData?.items || items
  
  return (
    <>
      {displayItems?.map((item, index) => (
        <Teaser
          key={`${index}-${item.title}`}
          item={item}
          showTag={false}
          showMetaTag={false}
          showMetaDate={false}
          showMetaTimeToRead={false}
          showButton={showButton}
          buttonLabel={buttonLabel}
        />
      ))}
    </>
  )
}
